import React from 'react';
import { Button } from '@thd-olt-component-react/button';
import { bool, number, shape, string } from 'prop-types';

const FULFILLMENT_METHOD_STH = 'ShipToHome';

const InstantCheckoutEnabled = ({
  atcRequest,
  fulfillmentMethod,
  instantCheckoutModel,
  channel,
  disabled,
}) => {
  let host = 'https://www.homedepot.com';
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    host = origin.match(/local/g) ? 'https://www.homedepot.com' : origin;
  }

  return (
    <div className="instant-checkout">
      <div className="instant-checkout__wrapper">
        <div className="instant-checkout__box instant-checkout__ic-min">
          <div className="ic-button">
            <Button
              disabled={disabled}
              outline
              className="atc_instant_checkout"
              onClick={(event) => {
                window.LIFE_CYCLE_EVENT_BUS.trigger('cart.instant-checkout', {
                  cartReqParams: atcRequest,
                  cartOptions: {
                    host,
                    channel,
                  },
                });
              }}
            >
              Instant Checkout
            </Button>
          </div>
          {fulfillmentMethod === FULFILLMENT_METHOD_STH && (
            <div className="no-justify-center">
              <span>
                Deliver to:&nbsp;
                <a href="/account/view/instantcheckout" className="u__default-link">
                  {instantCheckoutModel?.addressZipCode}
                </a>
                &nbsp;|&nbsp;
              </span>
              <span>
                <a href="/account/view/instantcheckout" className="u__default-link">
                  {instantCheckoutModel?.displayCardBrand}&nbsp;&#8226;&#8226;
                  {instantCheckoutModel?.xref}
                </a>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

InstantCheckoutEnabled.propTypes = {
  channel: string,
  fulfillmentMethod: string,
  atcRequest: shape({
    itemId: string,
    quantity: number,
    fulfillmentMethod: string,
    fulfillmentLocation: string,
  }),
  instantCheckoutModel: shape({
    addressZipCode: string,
    displayCardBrand: string,
    xref: string,
  }),
  disabled: bool,
};

InstantCheckoutEnabled.defaultProps = {
  channel: 'desktop',
  fulfillmentMethod: null,
  instantCheckoutModel: null,
  atcRequest: null,
  disabled: false,
};
export { InstantCheckoutEnabled };
